import { Injectable, Injector } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { UserDao } from '@app/dao/user/user.dao';
import { Heritage } from '@app/forms/subscription/definition/interface/subscription';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  userId;

  constructor(
    protected formConstructor: PrFormConstructor,
    protected injector: Injector,
  ) {
    super(formConstructor);
    injector
      .get(UserDao)
      .authOnce$()
      .subscribe(user => {
        this.userId = user.id;
      });
  }

  generateForm(entity: any) {
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        ownerId: [entity.ownerId],
        riskProfil: this.formBuilder.group({
          patrimonyValue: [
            entity?.riskProfil?.patrimonyValue || '',
            Validators.required,
          ],
        }),
        // patrimonyValue: [
        //   entity ? entity.patrimonyValue : "",
        //   Validators.required,
        // ],
        montant: [
          entity ? entity.montant : '',
          this.prFormService.AddValidatorsBasedOnCondition(
            this.prFormService
              .isTargetControlValueEqualTo('patrimonyValue', val => {
                return val == 8;
              })
              .bind(this),
            Validators.min(1000000),
          ),
        ],
      },
      options,
    );
  }
  generate(entity: Heritage[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      ownerId: this.userId,
    });
  }

  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  extract() {
    return this.form.value.owners;
  }
}
